// extracted by mini-css-extract-plugin
export default {"container":"bC_g","reversed":"bC_hv","textBlock":"bC_gd","title":"bC_cX","secondary":"bC_gS","description":"bC_c","button":"bC_dQ","containerWithCards":"bC_hw"};